// Placeholder untuk logo bank (sesuaikan dengan yang kamu punya)
const METHOD_LOGOS = {
  // VA_BRI: "https://upload.wikimedia.org/wikipedia/commons/2/2e/BRI_2020.svg",
  // VA_DANAMON: "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7b/Danamon.svg/1600px-Danamon.svg.png",
  // VA_MAYBANK: "https://seeklogo.com/images/M/maybank-logo-942F24DA55-seeklogo.com.png",
  // INDOMARET: "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9d/Logo_Indomaret.png/1600px-Logo_Indomaret.png",
  // ALFAMART: "https://upload.wikimedia.org/wikipedia/commons/9/9e/ALFAMART_LOGO_BARU.png",
  // QRIS: "https://upload.wikimedia.org/wikipedia/commons/thumb/a/a2/Logo_QRIS.svg/326px-Logo_QRIS.svg.png",
  VA_BRI: "/assets/images/payment-methods/BRI_2020.svg",
  VA_DANAMON: "/assets/images/payment-methods/1600px-Danamon.svg.png",
  VA_MAYBANK: "/assets/images/payment-methods/maybank.jpg",
  VA_BNI: "/assets/images/payment-methods/BNI.svg",
  VA_BCA: "/assets/images/payment-methods/Bank_Central_Asia.svg",
  VA_BCA_LINKQU: "/assets/images/payment-methods/Bank_Central_Asia.svg",
  VA_BRI_LINKQU: "/assets/images/payment-methods/BRI_2020.svg",
  VA_BNI_LINKQU: "/assets/images/payment-methods/BNI.svg",
  VA_DANAMON_LINKQU: "/assets/images/payment-methods/1600px-Danamon.svg.png",
  VA_MAYBANK_LINKQU: "/assets/images/payment-methods/maybank.jpg",
  VA_BSI: "/assets/images/payment-methods/Bank_Syariah_Indonesia.svg",
  VA_BSI_LINKQU: "/assets/images/payment-methods/Bank_Syariah_Indonesia.svg",
  VA_BSI: "/assets/images/payment-methods/Bank_Syariah_Indonesia.svg",
  VA_CIMB_LINKQU: "/assets/images/payment-methods/Bank_CIMB.svg",
  VA_BNC_LINKQU: "/assets/images/payment-methods/Bank_Neo_Commerce.png",
  VA_OCBC_LINKQU: "/assets/images/payment-methods/Bank_OCBC.png",
  VA_MUAMALAT_LINKQU: "/assets/images/payment-methods/Bank_Muamalat.png",
  VA_MANDIRI: "/assets/images/payment-methods/Bank_Mandiri.svg",
  VA_MANDIRI_LINKQU: "/assets/images/payment-methods/Bank_Mandiri.svg",
  VA_PERMATA: "/assets/images/payment-methods/Bank_Permatas_Logo.svg",
  VA_PERMATA_LINKQU: "/assets/images/payment-methods/Bank_Permatas_Logo.svg",
  INDOMARET: "/assets/images/payment-methods/indomaret.png",
  RETAIL_INDOMARET_LINKQU: "/assets/images/payment-methods/indomaret.png",
  ALFAMART: "/assets/images/payment-methods/alfamart-alfamidi.jpg",
  RETAIL_ALFAMART_LINKQU: "/assets/images/payment-methods/alfamart-alfamidi.jpg",
  QRIS: "/assets/images/payment-methods/Logo_QRIS.svg.png",
  EWALLET_SHOPEEPAY: "/assets/images/payment-methods/shopeepay.png",
  EWALLET_DANA: "/assets/images/payment-methods/dana.svg",
  EWALLET_OVO: "/assets/images/payment-methods/ovo-logo.png",
  EWALLET_GOPAY: "/assets/images/payment-methods/gopay.svg",
  CARD: "/assets/images/payment-methods/credit-card.svg",
  CREDIT_CARD: "/assets/images/payment-methods/credit-card.svg",
  NICEPAY_CARD: [
    "/assets/images/payment-methods/mastercard.svg",
    "/assets/images/card/visa-card.svg",
    "/assets/images/card/jcb-card.svg",
    "/assets/images/card/amex-card.svg",
  ],
  VISA: "/assets/images/card/visa-card.svg",
  MASTERCARD: "/assets/images/payment-methods/mastercard.svg",
  MASTER_CARD: "/assets/images/payment-methods/mastercard.svg",
  JCB: "/assets/images/card/jcb-card.svg",
  AMEX: "/assets/images/card/amex-card.svg",
};

export default METHOD_LOGOS;
